import React from 'react';
import cls from 'classnames';
import IconEarth from '../../UI/Icons/IconEarth';
import styles from './LangAndCurrency.module.scss';
import HeaderDropdown from '../HeaderDropdown/HeaderDropdown';
import Lang from './components/Lang/Lang';
import {useSelector} from 'react-redux';

function LangAndCurrency({className, btnClassName}) {
  const {language} = useSelector((state) => state.language);

  return (
    <div className={cls(styles.wrapper, className)}>
      <HeaderDropdown
        icon={<IconEarth/>}
        btnClassName={btnClassName}
        content={(props) => <Lang {...props}/>}
      />

      <span className={styles.currency}>{language?.split('-')[1]}</span>
    </div>
  );
}

export default LangAndCurrency;
